import SecureLink from './SecureLink'

export default SecureLink
